var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mx-auto p-4"},[_c('div',{staticClass:"mt-3 md:mt-6 text-center text-5xl"},[_vm._v(" Luxcaddy Touch Interface ")]),_c('touch-optimized-button',{staticClass:"mt-16",on:{"click":_vm.openMenu}},[_vm._v(" Ouvrir Menu ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }